import React from "react";
import { object, array } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { Link } from "@quintype/components";

import { getSlug } from "../../utils";

import CustomHeadline from "../../molecules/custom-headline/index";
import CardImageType3 from "../../molecules/card-image-type-3";
import CardImageType4 from "../../molecules/card-image-type-4";

import "./entertainment.m.css";

const EntertainmentRow = ({ collection, sections, config }) => {
  const [firstItem, ...restItems] = collection.items.filter(item => item.type === "story");

  const otherStories = restItems
    .slice(0, 6)
    .map(story => (
      <div key={story.id}>
        {story && <CardImageType4 story={story} headlineLimit={70} desktopWidths={[550]} mobileWidths={[250]} />}
      </div>
    ));

  const slug = getSlug(collection, sections);
  const text = config["page-type"] === "home-page" ? "Entertainment" : collection.name;

  return (
    <div styleName="wrapper">
      <div styleName="title-wrapper">
        <CustomHeadline text={text} color="white" headerType={10} href={slug} />
        {restItems.length > 6 && (
          <Link styleName="read-more read-more-desktop" href={slug}>
            <span>See More Stories</span>
          </Link>
        )}
      </div>
      <div styleName="stories-container">
        <CardImageType3 story={firstItem} headlineLimit={70} desktopWidths={[570]} mobileWidths={[640]} />
        <div styleName="other-stories-wrapper">{otherStories}</div>
      </div>
      {restItems.length > 6 && (
        <Link styleName="read-more read-more-mobile" href={slug}>
          <span>See More Stories</span>
        </Link>
      )}
    </div>
  );
};

EntertainmentRow.propTypes = {
  collection: object,
  sections: array,
  config: object
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], [])
  };
};

export default connect(
  mapStateToProps,
  null
)(EntertainmentRow);
